import React, { PureComponent } from "react";

export default class Svg extends PureComponent {
    static get defaultProps() {
        return {
            color: "#e2e2e2"
        };
    }

    static get propTypes() {
        return {
            color: React.PropTypes.string,
        };
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/svg/svg.js
 **/